const pillThemeConfig = {
  OG: {
    primaryColor: "#F15523",
    fontColor: "#fff",
    HoverText: "On-boarding guides",
  },
  LD: {
    primaryColor: "#3299FF",
    fontColor: "#fff",
    HoverText: "Learning & Development",
  },
  WFM: {
    primaryColor: "#2AA154",
    fontColor: "#fff",
    HoverText: "Workforce Management",
  },
  TA: {
    primaryColor: "#7D71E2",
    fontColor: "#fff",
    HoverText: "Talent Acquisition",
  },
  OPS: {
    primaryColor: "#C90370",
    fontColor: "#fff",
    HoverText: "Operations",
  },
};

export default pillThemeConfig;
